import React, { Component } from 'react';
import { FormSection, change as formChange, touch as formTouch } from 'redux-form';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {getFormValues} from 'redux-form'
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { TextField, DateField, DoubleTextField, SelectField } from 'src/jbc-front/components/Form';
import { isEmail, isDateStringFormat, isPersonalNumber, isEmpty, isPostalCode } from 'src/utils/CustomValidators';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { TelFieldTh } from 'src/components';
import isUseOtherApp from 'src/utils/JbcId';
import styles from './BasicInfoSection.scss';

class BasicInfoSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      provinces: [],
      subdistricts: [],
      nationalities: []
    };

    this._loadSelectOptions = this._loadSelectOptions.bind(this);
    this._handleProvinceChange = this._handleProvinceChange.bind(this);
    this._getLocalizedLabel = this._getLocalizedLabel.bind(this);
  }

  componentDidMount() {
    this._loadSelectOptions();
  }

  _getLocalizedLabel(element) {
    return this.props.i18n.language === 'vi' ? element.label : element.labelEn;
  }

  _loadSelectOptions() {
    const provincesArr = [];
    if (this.props.provinces && Array.isArray(this.props.provinces)) {
      this.props.provinces.forEach(element => {
        provincesArr.push({
          value: element.value,
          label: this._getLocalizedLabel(element)
        });
      });
    }

    this.setState(
      {
        provinces: provincesArr
      },
      () => {
        this._handleFilteredAddress(this.props.formValues?.employee?.provinceId);
      }
    );

    const nationalities = (this.props.nationalities || []).map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));
    this.setState({ nationalities });
  }

  _handleFilteredAddress(provinceId) {
    const subdistrictArr = (this.props.subdistricts[provinceId] || []).map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));

    this.setState({
      subdistricts: subdistrictArr
    });
  }

  _handleProvinceChange(provinceId) {
    if (!provinceId) {
      this.setState({ subdistricts: [] });
      return;
    }

    this.props.dispatch(formChange(EMPLOYEE_FORM, 'employee.subdistrictId', null));
    this._handleFilteredAddress(provinceId);
  }

  handleNationalityChange = nationalityId => {
    if (!nationalityId) return;
    this.props.dispatch(formChange(EMPLOYEE_FORM, 'employee.nationalityId', nationalityId));
  };

  render() {
    const { titles, t } = this.props;
    const isVietnamese = this.props.i18n.language === 'vi';
    return (
      <div>
        <FormSection name="employee">
          <DoubleTextField
            isReverse={isVietnamese}
            fields={[
              { name: 'firstName', label: t('features.Employees.components.BasicInfoSection.first_name'), fieldProps: { type: 'text', maxLength: 32 } },
              { name: 'lastName', label: t('features.Employees.components.BasicInfoSection.last_name'), fieldProps: { type: 'text', maxLength: 256 } }
            ]}
          />

          <DateField
            label={t('features.Employees.components.BasicInfoSection.birth_date')}
            viewMode="years"
            name="birthday"
            validate={isDateStringFormat}
          />

          <TelFieldTh label={t('components.TelField.Phone_number')} prefix={'tel'} />
          <div className={styles.wrap}>
            <TextField label={t('features.Employees.components.BasicInfoSection.email')} type="text" name="email" validate={isEmail} maxLength="255" />
            {isUseOtherApp && (
              <p>{t('features.Employees.components.BasicInfoSection.changed_email_address_will_also_be_reflected_in_other_JOBCAN_services_you_are_using')}</p>
            )}
          </div>

          <div className={styles.wrap}>
            <TextField
              label={t('features.Employees.components.BasicInfoSection.personal_id')}
              type="text"
              name="personalNumber"
              validate={isPersonalNumber}
              maxLength="13"
              required
              note={<p>{t('features.Employees.components.BasicInfoSection.please_enter_your_tax_id')}</p>}
            />
          </div>
          <div>
            <SelectField
              required
              label={t('features.Employees.components.BasicInfoSection.nationality')}
              name="nationalityId"
              options={this.state.nationalities}
              placeholder={t('features.Employees.components.BasicInfoSection.please_select')}
              validate={isEmpty}
              onChange={this.handleNationalityChange}
            />
          </div>
          <div>
            <SelectField
              label={t('features.Employees.components.BasicInfoSection.province')}
              name="provinceId"
              options={this.state.provinces}
              placeholder={t('features.Employees.components.BasicInfoSection.please_select')}
              onChange={this._handleProvinceChange}
            />
          </div>

          <div>
            <SelectField
              label={t('features.Employees.components.BasicInfoSection.subdistricts')}
              name="subdistrictId"
              options={this.state.subdistricts}
              placeholder={t('features.Employees.components.BasicInfoSection.please_select')}
            />
          </div>

          <div className={styles.wrap}>
            <TextField label={t('features.Employees.components.BasicInfoSectionShow.address_form')} type="text" name="address" />
          </div>

          <div className={styles.wrap}>
            <TextField label={t('features.Employees.components.BasicInfoSection.postal_code')} maxLength="10" validate={isPostalCode} name="postalCode" />
          </div>
        </FormSection>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  provinces: getSelectOptions(state, 'provinces'),
  subdistricts: getSelectOptions(state, 'subdistricts'),
  titles: getSelectOptions(state, 'titles'),
  nationalities: getSelectOptions(state, 'nationalities'),
  formValues: getFormValues(EMPLOYEE_FORM)(state)
});

export default withTranslation('translation')(connect(mapStateToProps)(BasicInfoSection));
